import { OrganizationProfileModel } from "api";
import { ReactNode, useLayoutEffect } from "react";
import UmamiManager from "./manager";

const UmamiContainer = ({
    children,
    profile,
    organization,
    initialProfileLoaded,
}: {
    children: ReactNode;
    profile: any;
    organization?: OrganizationProfileModel;
    initialProfileLoaded: boolean;
}) => {
    useLayoutEffect(() => {
        UmamiManager.init(profile, organization);
        if (initialProfileLoaded) {
            UmamiManager.identify(profile.id);
        }
    }, [profile, organization, initialProfileLoaded]);

    return children;
};

export default UmamiContainer;
